module.exports = __webpack_public_path__ + "img/field1.ba5bcb97.png";